import IButtonData from "../../shared/interfaces/button.interface";

export const BUTTON_NEXT: IButtonData[] = [
	{
		id: 'branch',
        variant: 'contained',
        color: 'error',
        textButton: "Continuar",
        size:'large'
	}
]